import { SearchOutlined } from '@ant-design/icons';
import SearchComponent from 'components/Global/SearchComponent';
import styles from './index.module.scss';

type Props = {
	searchValue: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
};

const FnfClearanceHeader = ({
	searchValue,
	handleSearch,
	handleSearchApi,
}: Props) => {
	return (
		<div className={styles['fnf-header']}>
			<SearchComponent
				className={styles['fnf-header-search']}
				placeHolder="Search employee..."
				prefixIcon={<SearchOutlined />}
				handleChange={handleSearch}
				handleChangeApi={handleSearchApi}
				value={searchValue}
				size="large"
			/>
		</div>
	);
};

export default FnfClearanceHeader;
